import { render, staticRenderFns } from "./arrivalAdmin.vue?vue&type=template&id=2675a6c2"
import script from "./arrivalAdmin.vue?vue&type=script&lang=js"
export * from "./arrivalAdmin.vue?vue&type=script&lang=js"
import style0 from "./arrivalAdmin.vue?vue&type=style&index=0&id=2675a6c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports